import React from 'react';
import { Menu } from './icons/Menu.js';
import { Crypto } from './icons/Crypto.js';
import { Casino } from './icons/Casino.js';
import { Chat } from './icons/Chat.js';
import { Sports } from './icons/Sports.js';

const Icon = ({ icon }) => {
  if (icon === "menu") {
    return /* @__PURE__ */ React.createElement(Menu, null);
  }
  if (icon === "crypto") {
    return /* @__PURE__ */ React.createElement(Crypto, null);
  }
  if (icon === "casino") {
    return /* @__PURE__ */ React.createElement(Casino, null);
  }
  if (icon === "chat") {
    return /* @__PURE__ */ React.createElement(Chat, null);
  }
  if (icon === "sports") {
    return /* @__PURE__ */ React.createElement(Sports, null);
  }
  return icon;
};

export { Icon };
//# sourceMappingURL=index.js.map
